import { styled } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";
import { colors } from "../../../theme/theme";

export const RootBox = styled(Box)({
  textAlign: "center",
});

export const CategorySection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const CategoryHeader = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  gap: "20px",
  justifyContent: "space-around",
  alignItems: "center",
  marginBottom: theme.spacing(2),
}));

export const Spacer = styled(Box)({
  width: "25%",
  height: 10,
});

export const CategoryTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  color: colors.primary,
  [theme.breakpoints.down("md")]: {
    fontSize: "1.2rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem",
  },
}));

export const ScoreGrid = styled(Box)({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
});

export const ScoreCell = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "isSelected" && prop !== "categoryColor",
})(({ theme, isSelected, categoryColor }) => ({
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(1, 2),
  border: "1px solid #000",
  cursor: "pointer",
  transition: "background-color 0.3s ease",
  backgroundColor: isSelected ? categoryColor : "transparent",
  "&:hover": {
    backgroundColor: categoryColor,
    opacity: 0.8,
  },
  "&:last-of-type": {
    borderRight: "2px solid #000",
  },
}));

export const ScoreCellTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})(({ isSelected }) => ({
  fontFamily: "'Gotham', sans-serif",
  color: isSelected ? "#fff" : "#000",
}));

export const TotalScoreTypography = styled(Typography)({
  fontFamily: "'Gotham', sans-serif",
  color: colors.primary,
  fontSize: "20px",
});

export const TotalScoreValue = styled(Typography)({
  fontFamily: "'Gotham', sans-serif",
  color: colors.primary,
  fontSize: "24px",
});

export const ChartContainer = styled(Box)({
  width: "100%",
  height: 400,
  marginTop: 0,
});
